import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-zinc-950 py-16 sm:py-24" data-id="element-120">
      <div className="max-w-3xl mx-auto px-4" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-emerald-500/10 via-emerald-500/5 to-cyan-500/10 border-2 border-emerald-500/30 rounded-3xl p-8 sm:p-12 text-center" data-id="element-122">
          <div className="w-20 h-20 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-123">
            <ShieldCheckIcon className="w-10 h-10 text-emerald-400" data-id="element-124" />
          </div>

          <h2 className="text-2xl sm:text-3xl font-black text-white mb-6" data-id="element-125">
            GARANTÍA <span className="text-emerald-400" data-id="element-126">100%</span> TOTAL
          </h2>

          <p className="text-lg sm:text-xl text-zinc-300 leading-relaxed mb-6" data-id="element-127">
            "Si seguiste todos los pasos y Magis TV no quedó instalado en tu
            dispositivo,{' '}
            <span className="text-white font-bold" data-id="element-128">
              te devolvemos el 100% de tu dinero.
            </span>{' '}
            Sin preguntas. Sin formularios. Sin demoras."
          </p>

          <div className="bg-zinc-900/50 rounded-xl p-6 inline-block" data-id="element-129">
            <p className="text-emerald-400 font-bold text-lg" data-id="element-130">
              Así de seguros estamos de que esta guía funciona.
            </p>
            <p className="text-zinc-400 mt-2" data-id="element-131">
              El riesgo es cero. El resultado es tuyo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}